/**
 * Created by Jerker Nord on 2020-06-02.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export class MonkeysGoldRowLockView extends BaseView {

    private _spineVines:PIXI.spine.Spine[];
    private _spineYellowSmoke:PIXI.spine.Spine[];
    private _spineVineOffset:PIXI.Point = new PIXI.Point(30, 0);
    private _spineYellowSmokeOffset:PIXI.Point = new PIXI.Point(60, 0);
    private _isRestore:boolean = false;
    private _restoreRows:number;

    constructor() {
        super();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.WIN_PRESENTATIONS_2.name).addChild(this);
    }

    protected initAnimations():void {
        this._spineVines = [];
        for(let i:number = 0; i < 6; i++) {
            let spineVine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("spineVines"));
            spineVine.position.x = Helper.getSymbolPositions(2, i)[0] + this._spineVineOffset.x;
            spineVine.position.y = Helper.getSymbolPositions(2, i)[1] + this._spineVineOffset.y;
            spineVine.visible = false;
            this.addChild(spineVine);
            this._spineVines.push(spineVine);
        }
        this._spineYellowSmoke = [];
        for(let i:number = 0; i < 6; i++) {
            let spineYellowSmoke:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("spineYellowSmoke"));//spineVines
            spineYellowSmoke.position.x = Helper.getSymbolPositions(2, i)[0] + this._spineYellowSmokeOffset.x;
            spineYellowSmoke.position.y = Helper.getSymbolPositions(2, i)[1] + this._spineYellowSmokeOffset.y;
            spineYellowSmoke.visible = false;
            this.addChild(spineYellowSmoke);
            this._spineYellowSmoke.push(spineYellowSmoke);
        }

        if(this._isRestore == true) {
            for(let i:number = 0; i < this._restoreRows; i++) {
                this._spineVines[5 - i].updateTransform();
                this._spineVines[5 - i].visible = true;
                this._spineVines[5 - i].skeleton.setSlotsToSetupPose();
                this._spineVines[5 - i].state.setAnimation(0, "vines_animation", false).timeScale = 6;
            }
        }
    }

    public doRestore(lockedRows:number):void {
        this._isRestore = true;
        this._restoreRows = lockedRows;
    }

    public getYellowSmokeAnimation(row:number):TimelineLite {
        const yellowSmokeAnimationTL:TimelineLite = new TimelineLite();
        yellowSmokeAnimationTL.add(() => this._spineYellowSmoke[row].alpha = 0);
        yellowSmokeAnimationTL.add(() => this._spineYellowSmoke[row].updateTransform());
        yellowSmokeAnimationTL.add(() => this._spineYellowSmoke[row].visible = true);
        yellowSmokeAnimationTL.add(() => this._spineYellowSmoke[row].skeleton.setSlotsToSetupPose());
        yellowSmokeAnimationTL.add([
            new TweenLite(this._spineYellowSmoke[row], 0.266, {alpha : 1, ease : Linear.easeNone}),
            new SpineTween(this._spineYellowSmoke[row], 0, "yellow_smoke_animation", 0)
        ]);
        yellowSmokeAnimationTL.add(new TweenLite(this._spineYellowSmoke[row], 0.266, {
            alpha : 0,
            ease : Linear.easeNone
        }), "-=0.266");
        return yellowSmokeAnimationTL;
    }

    public getVineAnimation(row:number):TimelineLite {
        const vineAnimationTL:TimelineLite = new TimelineLite();
        vineAnimationTL.add(() => this._spineVines[row].updateTransform());
        vineAnimationTL.add(() => this._spineVines[row].visible = true);
        vineAnimationTL.add(() => this._spineVines[row].skeleton.setSlotsToSetupPose());
        vineAnimationTL.add(() => this._spineVines[row].state.setAnimation(0, "vines_animation", false).timeScale = 3);
        return vineAnimationTL;
    }

    public resetAllAnimations():void {
        for(let i:number = 0; i < this._spineVines.length; i++) {
            this._spineVines[i].visible = false;
        }
        for(let i:number = 0; i < this._spineYellowSmoke.length; i++) {
            this._spineYellowSmoke[i].visible = false;
        }
    }
}